import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/Select";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";
import { FormattedMessage } from "react-intl";

const RealEstateFundManagementMenu = connectMenu<MenuProvided>(({ refine, currentRefinement }) => {
  const options = [
    { value: "Todos", label: <FormattedMessage defaultMessage="Todos" id="P8VfZA" /> },
    { value: "Ativa", label: <FormattedMessage defaultMessage="Ativa" id="YmDxXk" /> },
    { value: "Passiva", label: <FormattedMessage defaultMessage="Passiva" id="iA8XO4" /> },
  ];

  const selectValue = currentRefinement || "Todos";
  const selectedOption = options.find((opt) => opt.value === selectValue);

  return (
    <div className="space-y-4">
      <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">
        <FormattedMessage defaultMessage="Gestão" id="gRLfw9" />
      </h3>

      <Select
        value={selectValue}
        onValueChange={(value) => {
          refine(value === "Todos" ? "" : value);
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder={<FormattedMessage defaultMessage="Todos" id="P8VfZA" />}>
            {selectedOption?.label}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});

export default function RealEstateFundManagement() {
  return <RealEstateFundManagementMenu attribute="management" />;
}
